import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { MatterActivitiesDocument } from '~/graphql/queries/matterActivityQueries';

interface Props {
  matterId: string;
  skip?: boolean;
}

export const useMatterActivitiesQuery = ({ matterId, skip = false }: Props) => {
  const { data, loading, error, refetch } = useQuery(MatterActivitiesDocument, {
    variables: { matterId },
    skip: skip || !matterId,
  });

  const events = useMemo(
    () => data?.matterActivities ?? [],
    [data?.matterActivities],
  );

  return { events, isLoading: loading, error, refetch };
};
